import React, { PropsWithChildren } from "react";
import styled, { createGlobalStyle /*, ThemeProps*/ } from "styled-components";
import { SnackbarProvider } from "notistack";
import { Box, CssBaseline } from "@material-ui/core";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
// import Footer from "../components/Footer";
import Notifier from "../components/Notifier";
const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background #f7f7f7;
    overflow: hidden;
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const ContentWrapper = styled.div`
  height: calc(100vh - 80px);
`;

function Dashboard({ children }: PropsWithChildren<{}>) {
  return (
    <Root>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        autoHideDuration={3000}
      >
        <Notifier />
        <CssBaseline />
        <GlobalStyle />
        <Sidebar />
        <AppContent>
          <Header />
          <Box display="flex" flexDirection="column" flex={1}>
            <ContentWrapper>{children}</ContentWrapper>
          </Box>
        </AppContent>
      </SnackbarProvider>
    </Root>
  );
}

export default Dashboard;
